// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3twpg","row":"Node_row__rexww","label":"Node_label__2ZET_","footer":"Node_footer__3aKYB"};